<div *ngIf="isPopupVisible" class="popup card">
    <div class="popup-container">
        <div class="popup-body">
            <h3 class="text-center">Verify your Account</h3>
            <div class="text-center vbody">
                <div *ngIf="verificationText; else defaulttext">
                    <p>{{verificationText}}</p>
                    <img src="../../assets/img/success-icon-23194.png" alt="success" style="width: 100px;">
                </div>
                <ng-template #defaulttext>
                    <p>Your Account is yet to be verified. Check your mailbox or <a href="javascript:void(0);"
                            (click)="resendVerification()">resend</a> another verification mail.</p>
                </ng-template>
            </div>

        </div>
    </div>
</div>
<div *ngIf="isPopupVisible" class="overlay">
    
</div>